import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css';
import './style/index.scss'
// 图标库 面性图标
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';

import App from './App.vue'
import router from './router'
import pinia from './store'
import i18n from './global/i18n/index'
import $axios,{ globalAxios } from './global/request'
import TranslationService from '@/utils/translation.service';
import ConfigService from '@/utils/config.service';
import { commonStore } from './store/modules/common';
const translationService = new TranslationService(i18n);
translationService.refreshTranslation(localStorage.getItem('PAI-language') || 'zh_CN',true)
const configService = new ConfigService();
let app:any = null
const render = (_props:any=null) => {
  let container:any = null
  if (_props && _props.container) {
     container  = _props.container
  }
  /* tslint:disable */
  configService.init((result: any) => {
    // 检查 result 是否有数据
    if (!result || !result.data) {
      console.error('配置文件加载失败:', result);
      return;
    }
    // 设置全局 serverConfig
    (window as any).serverConfig = result.data;
    app = createApp(App)
    // 使用antd
    app.use(Antd)
    // 使用全局axios
    app.use(globalAxios, result.data)
    // 使用 pinia
    app.use(pinia)
    // 使用路由
    app.use(router)
    // 多语言
    app.use(i18n)
    app.provide('serverConfig', result.data)
    app.provide('translationService', translationService)
    // 如果是在主应用的环境下就挂载主应用的节点，否则挂载到本地
    router.isReady().then(() => app.mount(container ? container.querySelector('#centerApp') : '#centerApp'));

    // 设置浏览器tab标签页的标题
    nebulogyConfigObj();
    // 保存原始的 window.open 方法
    var originalWindowOpen:any = window.open;
    // 重写 window.open 方法
    // eslint-disable-next-line no-undef
    window.open = function (url:any, windowName: any, windowFeatures) {
      if(result.data.hasOwnProperty('ODL_FORM_URL') && result.data.hasOwnProperty('NEW_ROFM_URL')){
        url = decodeURIComponent(url);
        url = url.replace(result.data.ODL_FORM_URL,result.data.NEW_ROFM_URL);
      }
      var newUrl = url;
      // 蒙牛项目 拼接 ddtab=true
      if(result.data.AUTH_MODE === 'dingding') {
        // 在 URL 上拼接参数
        newUrl = appendParameter(url, 'ddtab', true);
        //  下载的时候 设置不添加 钉钉参数
        if(url.indexOf('ddtab') > -1){
          newUrl = appendParameter(url, 'ddtab', false);
        }
      }
      // 蒙牛项目 OA打开  拼接 cookies中的ticket
      if(result.data.AUTH_MODE === 'OA') {
        // 在 URL 上拼接参数
        let ticket = getCookie('Ticket') || getCookie('ssoticket');
        newUrl = appendParameter(url, 'Ticket', ticket);
      }
      // 调用原始的 window.open 方法
      return originalWindowOpen(newUrl, windowName, windowFeatures);
    };
  })
}
// 独立运行时
if (!(window as any).__POWERED_BY_QIANKUN__) {
  render()
}
export async function bootstrap() {
  console.log('bootstrap')
}
 
export async function mount(props: { container: Element }) {
  console.log('mount props:',props)
  render(props);
}
// 增加 update 钩子以便主应用手动更新微应用
export async function update(props: any) {
  console.log('update props:', props);
  router.push({ 'path': props.router, 'query': props.query })
}
 
export async function unmount() {
  console.log('unmount')
  app!.unmount();
  app!._container!.innerHTML = '';
  app = null;
}
/**
* 获取document的指定cookie值
* @description:
* @param {type}
* @return:
*/
function getCookie(v: string) {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    if (parts[0] === v) {
      return parts[1];
    }
  }
  return '';
}
/**
* 获取 当前系统页面配置数据
* @description:
* @param {type}
* @return:
*/
function nebulogyConfigObj(){
  // 浏览器标题
  $axios({
    method: 'post',
    url: 'object/api/last/nebulogyConfigObj/page',
    data: {},
  }).then((res:any)=>{
    if(res.responseCode === '100') {
      if(res.nebulogyConfigObjList.length > 0) {
        let result = res.nebulogyConfigObjList[0];
        document.title = result.browserTitle;
        commonStore().setNebulogyConfigInfo(result);
      }
    }
  }).catch((err:any) => {
    throw err;
  });
}


// 在 URL 上拼接参数
function appendParameter(url:string, paramName:string, paramValue: string | number | boolean) {
  // 检查 URL 是否已有参数
  var separator = (url.indexOf('?') !== -1) ? '&' : '?';
  // 返回新的 URL
  return url + separator + encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue);
}



